import { Tarjeta } from './ui';

export type LugarJugador = { lado: 'a' | 'b'; indice: 0 | 1 };

export function PasosCarga({ paso }: { paso: 1 | 2 }) {
  return <ol aria-label="Pasos para cargar el partido" className="flex items-center gap-3 text-sm">
    {(['Jugadores', 'Resultado'] as const).map((texto, i) => <li key={texto}
      aria-current={paso === i + 1 ? 'step' : undefined}
      className={`flex items-center gap-2 ${paso === i + 1 ? 'font-semibold text-(--color-acento)' : 'text-(--color-apagado)'}`}>
      {i === 1 && <span aria-hidden="true" className="mr-1 h-px w-6 bg-(--color-borde)" />}
      <span className={`flex h-7 w-7 items-center justify-center rounded-full border
        ${paso === i + 1 ? 'border-(--color-acento) bg-(--color-acento) text-(--color-sobre-acento)' : 'border-(--color-borde)'}`}>
        {paso === 2 && i === 0 ? '✓' : i + 1}
      </span>{texto}
    </li>)}
  </ol>;
}

export function InicialJugador({ nombre }: { nombre: string }) {
  return <span aria-hidden="true" className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full
    border border-(--color-borde) bg-(--color-heroe) text-sm font-bold">
    {nombre.trim().split(/\s+/).slice(0, 2).map(p => p[0]).join('')}
  </span>;
}

export function ParejaEnCarga({ numero, lado, personas, lugar, elegir, quitar, yo }: {
  numero: 1 | 2; lado: 'a' | 'b'; personas: ({ id: number; nombre: string } | null)[];
  lugar: LugarJugador | null; elegir: (lugar: LugarJugador) => void;
  quitar: (lugar: LugarJugador) => void; yo: number;
}) {
  return <Tarjeta sinRelleno className="flex min-w-0 flex-col gap-1.5 p-2">
    <h3 className="font-titulo text-lg">Pareja {numero}</h3>
    {([0, 1] as const).map(indice => {
      const persona = personas[indice];
      const seleccionado = lugar?.lado === lado && lugar.indice === indice;
      return <div key={indice} className={`flex min-h-11 items-center rounded-lg border
        ${seleccionado ? 'border-(--color-acento) bg-(--color-acento)/10' : 'border-(--color-borde) bg-(--color-panel)'}`}>
        <button type="button" onClick={() => elegir({ lado, indice })}
          aria-label={`Elegir jugador ${indice + 1} de Pareja ${numero}`} aria-pressed={seleccionado}
          className="flex min-h-11 min-w-0 flex-1 items-center gap-1 px-1.5 py-1 text-left">
          {!persona && <span aria-hidden="true" className="text-lg text-(--color-acento)">+</span>}
          <span className="min-w-0 break-words text-sm font-semibold">
            {persona?.nombre ?? 'Elegir jugador'}
            {persona?.id === yo && <span className="ml-1 text-xs font-normal text-(--color-acento)">vos</span>}
          </span>
        </button>
        {persona && <button type="button" aria-label={`Quitar ${persona.nombre} de Pareja ${numero}`}
          onClick={() => quitar({ lado, indice })} className="flex h-11 w-11 shrink-0 items-center justify-center text-xl text-(--color-apagado)">×</button>}
      </div>;
    })}
  </Tarjeta>;
}
